import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchService } from 'app/search/search.service';
import { AccountSearchSummary } from 'app/model/accountsearchsummary';
import { AlertService } from 'app/core/alert/alert.service';

@Component({
  selector: 'mifosx-cotizaciones',
  templateUrl: './cotizaciones.component.html',
  styleUrls: ['./cotizaciones.component.scss']
})
export class CotizacionesComponent implements OnInit {

  selectedCotizaciones: any;
  catizcionesForma: FormGroup;
  resultTableOffset: number = 1;
  searchData: any;
  cotizacionesTypo = [
      { value: 'abono_', displayName: 'Abono a capital' },
      { value: 'cacelacione_', displayName: 'Cancelación anticipada' },
  
  ];

  data: any; // Replace 'any' with an appropriate type if available

  // Pagination variables
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  index = 1;

  displayedColumns: string[] = ['ID','Parent Name', 'Loan Account No', 'Product Name']; //parentName, entityAccountNo, entityName

  constructor(private snackBar: AlertService,private formBuilder: FormBuilder,
      private loanAcctSearchService: SearchService,
      private router: Router,
      private route: ActivatedRoute
      ) { }

  ngOnInit(): void {
      this.catizcionesForma = this.formBuilder.group({
          'reportType': ['', Validators.required],
      });
  }

  onReportTypeChange(value: string) {
    this.catizcionesForma.addControl('searchData', new FormControl('',Validators.required));
   
  }
  
  onPageChange(event: any): void {
    this.pageIndex = event.pageIndex;
    this.fetchResults(this.searchData,this.pageIndex + 1)
  }

  fetchResults(searchData: any,offset: number = 0) {
    const loanAccountSummary$ = this.loanAcctSearchService.getLoanSearchResults<AccountSearchSummary[]>(searchData,offset.toString());
    loanAccountSummary$.subscribe((res: AccountSearchSummary[]) => {

      this.data = res;
      if(this.data.pageItems.length === 0){
        this.snackBar.alert({ type: 'Cotizaciones loan fetch failed', message: 'Datos no encontrados' });
      }
      this.pageIndex = 0;
      this.totalRecords = this.data.totalFilteredRecords;
  
  });
  }

  submit() {             
     
    this.searchData = this.catizcionesForma.get('searchData')?.value;
     
    if(this.searchData){
      this.fetchResults(this.searchData);      
      
    }
  }
}
